import type { ReactElement } from "react";
import { Link } from "react-router-dom";

export function NotFoundPage(): ReactElement {
  return (
    <section className="not-found">
      <h1>404</h1>
      <p>Страница не найдена.</p>
      <Link to="/" className="btn-primary">
        На главную
      </Link>
    </section>
  );
}
